/**
 * Custom DOMI-VISION icon — echoes the Domi-Vision logo:
 * a chunky retro camera whose lens is a pizza (red sauce + cheese spots,
 * concentric lens iris around it). Matches lucide-react API.
 *
 * Two-tone fill (red lens + slate body) — render unaffected by parent text colour
 * unless you pass `monochrome` to flatten everything to currentColor.
 */
export default function DomiVisionIcon({
  size = 24,
  strokeWidth = 1.6,
  className = "",
  monochrome = false,
}) {
  const body   = monochrome ? "currentColor" : "#ffffff";
  const lens   = monochrome ? "none"         : "#E31C2A"; // logo red
  const cheese = monochrome ? "currentColor" : "#FFD66B"; // mozzarella spots
  const stroke = "currentColor";

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {/* Camera body (rounded square) */}
      <rect x="2.5" y="6.5" width="19" height="13" rx="2.6" fill={monochrome ? "none" : "rgba(255,255,255,0.08)"} />
      {/* Hot-shoe / viewfinder bump */}
      <path d="M9 6.5 L10 4.5 H14 L15 6.5 Z" fill={body} />
      {/* Shutter button */}
      <circle cx="18.5" cy="8.5" r="0.7" fill={body} stroke="none" />

      {/* Outer iris (camera lens ring) */}
      <circle cx="12" cy="13" r="4.6" />
      {/* Pizza disc */}
      <circle cx="12" cy="13" r="3.4" fill={lens} stroke={stroke} />
      {/* Cheese / pepperoni spots */}
      <circle cx="10.8" cy="12.0" r="0.55" fill={cheese} stroke="none" />
      <circle cx="13.2" cy="11.9" r="0.45" fill={cheese} stroke="none" />
      <circle cx="11.4" cy="14.2" r="0.5"  fill={cheese} stroke="none" />
      <circle cx="13.3" cy="14.0" r="0.4"  fill={cheese} stroke="none" />
      {/* Lens highlight (top-left glint) */}
      <path d="M10.0 11.3 Q10.7 10.6 11.7 10.7" stroke={body} fill="none" strokeWidth={strokeWidth * 0.8} />
    </svg>
  );
}
